/**
 * @fileoverview GET handler for the "/engagement/email_templates/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplatesTags } from "./constants";
import type { EngagementEmailTemplatesTagsResult } from "./types";

export const getEngagementEmailTemplatesTags = reactQueryFetcherAdapter(
  engagementEmailTemplatesTags,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementEmailTemplatesTagsResult> => {
    return fetch("/engagement/email_templates/tags", "GET", { app_group_id: appGroupId }, { signal });
  }
);
